export default __webpack_public_path__ + "static/media/hand-with-chocolate-lyte@2x.bbec5a1a.png";